import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import smoothscroll from 'smoothscroll-polyfill';
import { nativeApi } from './NativeAPI';
import { PermissionModal } from './PermissionModal';

smoothscroll.polyfill();

function getScrollParent(node) {
    if (node == null) {
        return null;
    }

    if (node.scrollHeight > node.clientHeight) {
        return node;
    } else {
        return getScrollParent(node.parentNode);
    }
}

function _ExpoIntegration({ platform }) {
    const location = useLocation();
    const [message, setMessage] = useState(null);
    const [attachedKeyboardFix, setAttachedKeyboardFix] = useState(false);
    let offsetTop = null;

    const onFocusOut = event => {
        const targetNode = event.target;
        if (targetNode) {
            const tagName = targetNode.tagName.toLowerCase();
            if (targetNode.type !== 'submit' && (tagName === 'input' || tagName === 'textarea')) {
                setTimeout(() => {
                    if (offsetTop !== null) {
                        const active = document.activeElement;
                        if (active.tagName.toLowerCase() !== 'input' || active === targetNode) {
                            window.scrollTo(0, offsetTop);
                            offsetTop = null;
                        }
                    }
                }, 1);
            }
        }
    };

    const onFocusIn = event => {
        const targetNode = event.target;
        if (targetNode) {
            const tagName = targetNode.tagName.toLowerCase();
            if (targetNode.type !== 'submit' && (tagName === 'input' || tagName === 'textarea')) {
                offsetTop = window.scrollY;
                const active = document.activeElement;
                setTimeout(() => {
                    active.scrollIntoView();
                }, 100);
            }
        }
    };

    const isNative = () => platform?.platform === 'ios' || platform?.platform === 'android';

    const checkNative = () => {
        if (isNative()) {
            nativeApi.setNative(true);
            window.onerror = function (message, url, lineNumber) {
                nativeApi.log(message);
                // nativeAPI.log({lineNumber, message});
                return false;
            };
        }
    };

    useEffect(() => {
        checkNative();
    }, [platform]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    useEffect(() => {
        if (platform?.platform === 'ios' && !attachedKeyboardFix) {
            setAttachedKeyboardFix(true);
            document.addEventListener('focusout', onFocusOut, false);
            document.addEventListener('focusin', onFocusIn, false);
        }

        return () => {
            if (platform?.platform === 'ios') {
                document.removeEventListener('focusin', onFocusIn, false);
                document.removeEventListener('focusout', onFocusOut, false);
            }
        };
    }, [platform, attachedKeyboardFix]);

    if (message) {
        return message;
    }

    return <PermissionModal />;
}

export const ExpoIntegration = connect(state => ({ platform: state.platform }))(_ExpoIntegration);
